import React from 'react'
import { ChartLine, Dollar, Gem, Box } from '@primer-io/goat-icons'

import OperationalEfficiencySmall from './assets/operational-efficiency-small.png'
import OperationalEfficiency from './assets/operational-efficiency.png'
import PaymentOrchestrationSmall from './assets/payment-orchestration-small.png'
import PaymentOrchestration from './assets/payment-orchestration.png'

import JiraImg from 'assets/svg/automation/carousel/jira.svg'
import MailchimpImg from 'assets/svg/automation/carousel/mailchimp.svg'
import PostmarkImg from 'assets/svg/automation/carousel/postmark.svg'
import RiskifiedImg from 'assets/svg/automation/carousel/riskified.svg'
import SendgridImg from 'assets/svg/automation/carousel/sendgrid.svg'
import SlackImg from 'assets/svg/automation/carousel/slack.svg'
import TwillioImg from 'assets/svg/automation/carousel/twillio.svg'
import ZendeskImg from 'assets/svg/automation/carousel/zendesk.svg'

export const useCases = [
	{
		icon: Dollar,
		title: 'Payment Orchestration',
		imgSrc: PaymentOrchestration,
		imgSrcSmall: PaymentOrchestrationSmall,
	},
	{
		icon: ChartLine,
		title: 'Operational Efficiency',
		imgSrc: OperationalEfficiency,
		imgSrcSmall: OperationalEfficiencySmall,
	}
]

export const workflowApps = [
	{ name: 'Mailchimp', logo: <MailchimpImg /> },
	{ name: 'Slack', logo: <SlackImg /> },
	{ name: 'Zendesk', logo: <ZendeskImg /> },
	{ name: 'Sendgrid', logo: <SendgridImg /> },
	{ name: 'Riskified', logo: <RiskifiedImg /> },
	{ name: 'Jira', logo: <JiraImg /> },
	{ name: 'Twillio', logo: <TwillioImg /> },
	{ name: 'Postmark', logo: <PostmarkImg /> },
]
